/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 限时抢券活动时间轴
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.ActivityLimitCouponTimeDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cms/getLimitCouponActivityTimes`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
